export default __webpack_public_path__ + "static/media/Red Deviled Dates.f71d1ab0.jpg";